export default __webpack_public_path__ + "static/media/12.8f9c918a.png";